import { render, staticRenderFns } from "./aiTest.vue?vue&type=template&id=8c8cbb46&scoped=true&"
import script from "./aiTest.vue?vue&type=script&lang=js&"
export * from "./aiTest.vue?vue&type=script&lang=js&"
import style0 from "./aiTest.vue?vue&type=style&index=0&id=8c8cbb46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8cbb46",
  null
  
)

export default component.exports